import { validateDatePair } from '@/core/validators';

export default function validateFromAndTo(obj) {
	let errors = {};
	[errors.etd, errors.eta] = validateDatePair(obj.etd, obj.eta);

	return errors;
}